/*
 * table自适应逻辑
 * th 表头
 * td 表格内容
 */
export default {
    data() {
        return {
            notSelfAdaptionList: ['/masterdata/experimentTemplate/experimentTemplateEdit',
                '/experimentCenter/NucleicAcidExtraction/ExperimentCenterNAEEdit',
                '/masterdata/researchTemplate/researchTemplateEdit', '/experimentCenter/ResearchCenter/researchCenterEdit',
                '/samplelibrary/SampleStorage', '/project/RdReport/RdReportEdit'],
        }
    },
    methods: {
        deepClone(target) {
            const map = new WeakMap()

            function isObject(target) {
                return (typeof target === 'object' && target) || typeof target === 'function'
            }

            function clone(data) {
                if (!isObject(data)) {
                    return data
                }
                if ([Date, RegExp].includes(data.constructor)) {
                    return new data.constructor(data)
                }
                if (typeof data === 'function') {
                    return new Function('return ' + data.toString())()
                }
                const exist = map.get(data)
                if (exist) {
                    return exist
                }
                if (data instanceof Map) {
                    const result = new Map()
                    map.set(data, result)
                    data.forEach((val, key) => {
                        if (isObject(val)) {
                            result.set(key, clone(val))
                        } else {
                            result.set(key, val)
                        }
                    })
                    return result
                }
                if (data instanceof Set) {
                    const result = new Set()
                    map.set(data, result)
                    data.forEach(val => {
                        if (isObject(val)) {
                            result.add(clone(val))
                        } else {
                            result.add(val)
                        }
                    })
                    return result
                }
                const keys = Reflect.ownKeys(data)
                const allDesc = Object.getOwnPropertyDescriptors(data)
                const result = Object.create(Object.getPrototypeOf(data), allDesc)
                map.set(data, result)
                keys.forEach(key => {
                    const val = data[key]
                    if (isObject(val)) {
                        result[key] = clone(val)
                    } else {
                        result[key] = val
                    }
                })
                return result
            }

            return clone(target)
        },
        clone(obj){
            let copiedObjects = new WeakMap();
            if (typeof obj !== 'object' || obj === null) {
                return obj;
            }
            if (copiedObjects.has(obj)) {
                return copiedObjects.get(obj);
            }
            let copy;
            if (Array.isArray(obj)) {
                copy = [];
            } else {
                copy = {};
            }
            copiedObjects.set(obj, copy);
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (typeof obj[key] === 'object' && obj[key] !== null) {
                        copy[key] = this.clone(obj[key], copiedObjects);
                    } else {
                        copy[key] = obj[key];
                    }
                }
            }
            return copy;
        
        },
        changeText(text) {
            return '\u00A0' + (text || '')
        },
        testChangeText(text) {
            return /\u00A0/.test(text)
        },
        clickSelfAdption(dom) {
            dom.forEach(element => {
                // console.log(element?.needSelfAdption,'ssss')
                if (element?.needSelfAdption) {
                    let { needSelfAdption, selfAdptionClass } = element?.needSelfAdption
                    this.selfAdption(needSelfAdption, selfAdptionClass)
                }
                if (element?.$props) {
                    let { needSelfAdption, selfAdptionClass } = element?.$props
                    this.selfAdption(needSelfAdption, selfAdptionClass)
                }
            });
        },
        selfAdption(needSelfAdption = this.needSelfAdption, selfAdptionClass = this.selfAdptionClass) {
            // console.log(needSelfAdption)
            // console.log(selfAdptionClass)
            return ''
            if (!needSelfAdption) return
            var resultClass = !selfAdptionClass ? '' : selfAdptionClass
            this.$nextTick(() => {
                var thArr = this.getDomAll(resultClass + ' .p-datatable-lg .p-sortable-column')
                /**
                 * 需要调用2遍this.$nextTick,重新获取thArr这个dom，否则会有bug。。。。
                 * */
                this.$nextTick(() => {
                    thArr = this.getDomAll(resultClass + ' .p-datatable-lg th:not([class*="bio_datatable_column"])')
                    var tBodyTr = this.getDomAll(resultClass + ' .p-datatable-tbody tr')
                    if (!tBodyTr) return
                    Array.from(thArr).forEach(el => {
                        Object.assign(el.style, {
                            width: 'auto',
                        })
                    })
                    var arrWidth = Array.from(thArr).map(el => el.offsetWidth).filter(i => i != 0)
                    tBodyTr.forEach(el => Array.from(el.children).forEach((item, index) => item.style.width = (arrWidth[index]) + 'px'))
                    this.handleScroll(resultClass, needSelfAdption)
                })
            })
        },
        handleScroll(resultClass, needSelfAdption) {
            let changeWidthFun = (tdArr, thArr, index, el) => {
                if (tdArr[0]?.innerHTML?.includes('p-checkbox') || tdArr[0]?.innerHTML?.includes('p-radiobutton')) {
                    if (tdArr[index]?.innerHTML?.includes('p-checkbox') || tdArr[index]?.innerHTML?.includes('p-radiobutton')) {
                        el.style.width = '42px'
                    } else {
                        el.style.width = 100 / (tdArr.length - 1) + '%'
                    }
                } else {
                    el.style.width = 100 / tdArr.length + '%'
                }
            }
            if (!resultClass) resultClass = ''
            let tabWid = this.getDom(resultClass + ' .p-datatable-wrapper').offsetWidth
            let wrapperWid = this.getDom(resultClass + ' .p-datatable-wrapper').scrollWidth
            // console.log(tabWid, wrapperWid)
            if (tabWid == wrapperWid) {
                var tBodyTr = this.getDomAll(resultClass + ' .p-datatable-tbody tr')
                let thArr = this.getDomAll(resultClass + ' .p-datatable-lg th:not([class*="bio_datatable_column"])')
                tBodyTr.forEach(el => {
                    let tdArr = Array.from(el.children).filter(e => !e.className.includes('bio_datatable_column'))
                    tdArr.forEach((el, index) => {
                        changeWidthFun(tdArr, thArr, index, el)
                    })
                    thArr.forEach((el, index) => {
                        changeWidthFun(tdArr, thArr, index, el)
                    })
                    if (tdArr.length == 1 && (tdArr[0].innerText == '加载数据中' || tdArr[0].innerText == '没有数据')) {
                        //  表头
                        if (thArr[0].innerHTML.includes('p-checkbox') || thArr[0].innerHTML.includes('p-radiobutton')) {
                            Array.from(thArr).forEach((item, index) => {
                                if (index == 0) {
                                    thArr[index].style.width = '42px'
                                } else {
                                    thArr[index].style.width = 100 / (thArr.length - 1) + '%'
                                }
                                tdArr[0].style.width = 'calc(100% + 42px)'
                            })
                        } else {
                            el.style.width = 100 / tdArr.length + '%'
                            thArr.forEach((item) => {
                                item.style.width = 100 / thArr.length + '%'
                            })
                        }
                    }
                })
            } else {
                var tBodyTr = this.getDomAll(resultClass + ' .p-datatable-tbody tr')
                let thArr = this.getDomAll(resultClass + ' .p-datatable-lg th:not([class*="bio_datatable_column"])')
                // console.log(tBodyTr)
                // console.log(thArr)
                tBodyTr.forEach((el, index) => {
                    let tdArr = Array.from(el.children).filter(e => !e.className.includes('bio_datatable_column'))
                    if (tdArr.length == 1 && (tdArr[0].innerText == '加载数据中' || tdArr[0].innerText == '没有数据')) {
                        tdArr[0].style.width = '100%'
                    } else {
                        let widthArr = Array.from(thArr).map(el => el.offsetWidth)
                        // console.log( tdArr,'sssssssaaaaaaa')
                        Array.from(tdArr).forEach((item, key) => {
                            // console.log(item,key,widthArr[key])
                            item.style.width = widthArr[key] + 'px'
                        })
                        let time;
                        if (time) clearTimeout(time)
                        time = setTimeout(() => {
                            if (Array.from(tdArr)[1].offsetWidth != widthArr[1]) {
                                this.selfAdption(needSelfAdption, resultClass)
                            }
                        }, 500)


                    }

                })
            }
        },
        getDomAll(dom) {
            return document.querySelectorAll(dom)
        },
        getDom(dom) {
            return document.querySelector(dom)
        },
        initTableTd() {
            $('.setClassTd td').each((index, el) => {
                if (el.offsetHeight < 45) {
                    el.style.height = '45px'
                }
            })
            if (!$(".bio_datatable_column")[0]?.style?.width.includes("px")) {
                $(".bio_datatable_column").css({
                    width: '150px'
                })
            }
        },
        asynsInitFun() {
            var time = setInterval(() => {
                this.initTableTd()
            }, 20)
            setTimeout(() => {
                clearInterval(time)
                time = null
            }, 3000)
        },
        newSelfAdption() {
            for (let index = 0; index < this.notSelfAdaptionList.length; index++) {
                var element = this.notSelfAdaptionList[index];
                if (location.href.includes(element)) return
            }
            $(".p-datatable-thead").each((el, item) => {
                item.className = 'setClassTh'
            })

            $(".p-datatable-tbody").each((el, item) => {
                item.className = 'setClassTd'
                item.style.backgroundColor = '#fff'
                this.asynsInitFun()
            })
            Array.from($("table")).forEach(el => {
                $(el).css({
                    'border-color': '#DFE3EA',
                    // 'border-collapse': 'separate'
                })
            })
        },
        selfActionWidtFieldset() {
            // SampleCenterSampleMasterListRight.vue
            this.selfActionWidth = $('.col-9')[0]?.offsetWidth - 50 + 'px'
            window.addEventListener("resize", () => {
                this.selfActionWidth = $('.col-9')[0]?.offsetWidth - 50 + 'px'
            })
        }
    },

    updated() {

        window._.throttle(() => {
            this.initTableTd()
        })

    }
}